/**
 * @file
 * Search toggle link.
 */

(function searchToggleLinkScript($, Drupal, once) {
  'use strict';

  function closeLinkClickKeydownListener(event) {
    event.preventDefault();
    event.stopPropagation();
    if (event.type === 'keydown' &&
        // Key is not Enter or Space.
        (event.key !== 'Enter' && event.key !== ' ')) {
      return;
    }

    const $closeLink = $(event.currentTarget);
    const $toggleLink = $closeLink.data('searchToggleLink');
    if (typeof $toggleLink !== 'undefined' && $toggleLink) {
      /* eslint-disable no-use-before-define */
      collapse($toggleLink);
      /* eslint-enable no-use-before-define */
    }

    $closeLink.addClass('hidden');
  }

  /**
   * Create or get the close link.
   *
   * @param {HTMLElement|jQuery} toggleLink
   *   The toggle link.
   *
   * @return {jQuery}
   *  The jQuery for ".search-toggle-link__close".
   */
  function getCloseLink(toggleLink) {
    const $toggleLink = $(toggleLink);
    if ($toggleLink.length === 0) {
      return $([]);
    }

    // Use the stored close link if it exist.
    const storedClose = $toggleLink.data('searchToggleCloseLink');
    if (typeof storedClose !== typeof undefined && storedClose !== null) {
      const $storedClose = $(storedClose);
      if ($storedClose.length > 0) {
        return $storedClose;
      }
    }

    const text = $toggleLink.data('closeLinkText');
    let context = $toggleLink.data('closeLinkContext');
    let $close;

    // No text means no link.
    if (typeof text === typeof undefined || !text) {
      return $([]);
    }

    // Set a default context.
    if (typeof context === typeof undefined) {
      context = '.page__sidebar-first--inner';
    }

    const $context = $(context);
    if ($context.length === 0) {
      return $([]);
    }

    $close = $context.find('.search-toggle-link__close');
    if ($close.length > 0) {
      return $close;
    }

    // Create the close link.
    $close = $(`<div class="search-toggle-link__close"><button class="search-toggle-link__close-link">${text}</button></div>`);

    // Store the references to each other.
    $close.data('searchToggleLink', $toggleLink.get(0));
    $toggleLink.data('searchToggleCloseLink', $close.get(0));

    // Click handler.
    $(once('searchToggleLinkCloseOnClick', $close)).on('click keydown', closeLinkClickKeydownListener);

    // Append to the context.
    $close.appendTo($context);

    return $close;
  }

  /**
   * Collapse the toggle.
   *
   * @param {HTMLElement|jQuery} toggleLink
   *   The toggle link.
   */
  function collapse(toggleLink) {
    const $toggleLink = $(toggleLink);
    $toggleLink
      .attr('aria-expanded', 'false')
      .removeClass('search-toggle-link__link--expanded');
    getCloseLink($toggleLink).addClass('hidden');
    $('body').removeClass('body--search-toggle-link-expanded');
    Drupal.ahsThemeSite.scrollTop($toggleLink);
  }

  /**
   * Expand the toggle.
   *
   * @param {HTMLElement|jQuery} toggleLink
   *   The toggle link.
   */
  function expand(toggleLink) {
    const $toggleLink = $(toggleLink);
    $toggleLink
      .attr('aria-expanded', 'true')
      .addClass('search-toggle-link__link--expanded');

    $('body').addClass('body--search-toggle-link-expanded').trigger('searchToggleLinkExpanded');

    getCloseLink($toggleLink).removeClass('hidden');
  }

  function toggleLinkClickKeydownListener(event) {
    if (event.type === 'keydown' &&
        // Key is not Enter or Space.
        (event.key !== 'Enter' && event.key !== ' ')) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    const $link = $(event.currentTarget);
    let wasExpanded = $link.hasClass('search-toggle-link__link--expanded');
    wasExpanded = typeof wasExpanded !== typeof undefined && wasExpanded !== null ?
      wasExpanded :
      false;
    if (wasExpanded) {
      collapse($link);
    } else {
      expand($link);
    }
  }

  Drupal.behaviors.themeSearchToggleLink = {
    attach(context) {
      const links = once('themeSearchToggleLinkAttach', '.search-toggle-link__link', context);
      if (!links.length) {
        return;
      }

      $(links).on('click keydown', toggleLinkClickKeydownListener);
    },
  };
}(jQuery, Drupal, once));
